<template lang="pug">
el-container.outer(v-loading="loading")
  el-container
    el-header.relative(style="height: 90px")
      el-row(style="margin: 10px 0 10px 0px")
        el-col(:span="24")
          span 当前目录信息和层级关系
          el-select(v-model="orderKey", placeholder="请选择", size="small", style="margin-left: 10px; vertical-align: middle", @change="catalogChange")
            el-option(v-for="(item, index) in orderRuleList", :key="index", :label="item.orderName", :value="item.orderCode")
      .preview-tips(@click="triggerAside", :class="{ open: showPreview }")
        i.el-icon-s-unfold
      div(style="height: 32px; display: flex; justify-content: space-between; padding-right: 20px")
        div
          el-button(
            v-for="(item, index) in butArr",
            :disabled="disabledFu(item, index)",
            :icon="index ? 'el-icon-document-copy' : 'el-icon-plus'",
            :key="index",
            :plain="index > 0",
            size="small",
            :type="disabledFu(item, index) ? 'default' : 'primary'",
            @click="handleBtnClick(item, index, item.action)"
          ) {{ item.butName }}
        el-button(icon="el-icon-download", size="small", @click="exportList") 导出
    el-container
      el-main.container
        el-table.jy-table(
          height="100%",
          ref="tree",
          @current-change="handleNodeClick",
          highlight-current-row,
          :data="childrenList",
          row-key="folderId",
          :indent="12",
          :default-expand-all="true",
          :tree-props="defaultProps"
          border
        )
          el-table-column(v-slot="{ row }", v-bind="treeColumnProps", label="目录名称", prop="folderName")
            .level-stage(:style="{ marginLeft: 24 + row.level * 12 + 'px' }")
              img.f-icon(:src="folderTypeEnum[row.typeName].icon")/
              span.tree-name(:class="{ isActive: row.isActive }", :title="row.folderName") 【{{ folderTypeEnum[row.typeName].name }}】{{ row.folderName }}
          el-table-column(v-slot="{ row: data }", v-bind="optColumnProps", label="操作", prop="opt")
            el-button.ml-0(:disabled="disabledUp(data)", icon="el-icon-top", title="上移", size="mini", type="text", @click="nodeUp(data)")
            el-button.ml-0(:disabled="disabledDn(data)", icon="el-icon-bottom", title="下移", size="mini", type="text", @click="nodeDown(data)")
            el-dropdown(@command="handleCommand", size="small")
              el-button(icon="el-icon-more", type="text", size="mini", title="更多")
              el-dropdown-menu(slot="dropdown")
                template(v-if="data.subordinateName")
                  el-dropdown-item(
                    icon="el-icon-plus",
                    :disabled="!data.canEdit",
                    size="mini",
                    type="text",
                    :title="getAddTitle(data.subordinateName)",
                    :command="[handleAddChildNode, data]"
                  ) {{ data.subordinateName }}
                  el-dropdown-item(
                    icon="el-icon-document-copy",
                    size="mini",
                    type="text",
                    :title="getCopyTitle(data.subordinateName)",
                    :command="[copyChildrenTo, data, 'copyTo']"
                  ) {{ data.subordinateName }}
                el-dropdown-item(:disabled="!data.canEdit", :icon="data.isActive ? 'el-icon-close' : 'el-icon-check'", size="mini", type="text", :command="[toggleDisabled, data]") {{ data.isActive ? "禁用" : "启用" }}
                el-dropdown-item(v-if="!data.isPublish", :disabled="!data.canEdit", icon="el-icon-delete", size="mini", type="text", :command="[remove, data]") 删除
          template(v-if="showUserPlan")
            el-table-column(v-slot="{ row }", show-overflow-tooltip, label="编号", prop="folderNo", width="150px", align="center")
              .table-cell-edit-block(:disabled="!row.canEdit", @click="editFolderNo(row)") {{ row.folderNo }}
            el-table-column(
              v-for="role in roleList",
              show-overflow-tooltip,
              v-slot="{ row }",
              :key="role.id",
              :label="role.cnName",
              :prop="role.id",
              align="center",
              min-width="140px"
            )
              .table-cell-edit-block(:disabled="!row.canEdit", @click="addUser(row, role)") {{ row[role.nameKey] }}
      el-footer
        el-button(:disabled="catalogInit === '0'", :loading="rollbackLoading", type="info", @click="rollback" size="small") 恢复至最后一次发布状态
        el-button(:loading="saveChangeLoading", type="primary", @click="saveChange('')" size="small") 保存更改
        el-button(:loading="publishChangeLoading", type="primary", @click="publishChange" size="small") 发布
  el-aside.relative(v-if="showPreview", width="250px")
    preview-tree(:csget-params="csgetParams", :order-assistants="orderAssistants", ref="previewTree", :tree-data="childrenList")
  selectOrderRuleDlg(:order-rule-list="orderRuleList", ref="selectOrderRuleDlg", @ok="onOrderKeyChanged")
  selectSpecDlg(:data="childrenList", :first="first", ref="selectSpecDlg", :tree-data="treeData", @callback="afterSpecSelected")
  selectChildDlg(:data="childrenList", :first="first", ref="selectChildDlg", :tree-data="treeData", @callback="afterChildSelected")
  selectStageDlg(:data="childrenList", :first="first", ref="selectStageDlg", :tree-data="treeData", @callback="afterStageSelected")
  selectUnitDlg(:data="childrenList", :first="first", ref="selectUnitDlg", :tree-data="treeData", @callback="afterUnitSelected")
  copyToDlg(:data="childrenList", :order-rule="orderAssistants", ref="copyToDlg", :tree-data="treeData", @callback="handleCopyTo")
  editFolderNoDlg(ref="editFolderNoDlg")
</template>
<script>
import { mapState, mapActions } from "vuex";
import folderService from "@/CommonDP/service/folder-service";
import PreviewTree from "../previewTree.vue";
import selectSpecDlg from "./selectSpecDlg.vue";
import selectChildDlg from "./selectChildDlg.vue";
import selectStageDlg from "./selectStageDlg.vue";
import selectUnitDlg from "./selectUnitDlg.vue";
import copyToDlg from "./copyToDlg.vue";
import selectOrderRuleDlg from "./selectOrderRuleDlg.vue";
import editFolderNoDlg from "./editFolderNoDlg";
import stageIcon from "./assets/stage.svg";
import childIcon from "./assets/child.svg";
import specIcon from "./assets/spec.svg";
import { TreeUtils } from "@/CommonDP/utils/tree";
import { openMember } from "@/CommonDP/components/chooseMember/leftCom.js";
import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";
import { v4 as uuidv4 } from "uuid";
import globalParams from "@/CommonDP/utils/globalParams";
export default {
  components: { PreviewTree, selectSpecDlg, selectChildDlg, selectStageDlg, selectUnitDlg, copyToDlg, selectOrderRuleDlg, editFolderNoDlg },
  data() {
    return {
      disableUserPlan: globalParams.get("prjPlan.disableUserPlan") ?? 0,
      loading: false,
      rollbackLoading: false,
      saveChangeLoading: false,
      publishChangeLoading: false,
      orderRuleList: [],
      // 层级类型的字典数据。1-阶段/单元，2-专业，3-子项
      orderAssistants: [],
      orderKey: "",
      directoryStatus: null,
      selectedOrderKey: "",
      childrenList: [],
      csgetParams: {},
      butArr: [],
      defaultProps: {
        children: "childrenList"
      },
      roleList: [
        { cnName: "负责人", id: "managerUserIds", nameKey: "managerUserNameStr" },
        { cnName: "制图人", id: "drawUserIds", nameKey: "drawUserNameStr" },
        { cnName: "设计人", id: "designUserIds", nameKey: "designUserNameStr" },
        { cnName: "校对人", id: "checkUserIds", nameKey: "checkUserNameStr" },
        { cnName: "审核人", id: "reviewUserIds", nameKey: "reviewUserNameStr" },
        { cnName: "审定人", id: "authorizeUserIds", nameKey: "authorizeUserNameStr" }
      ],
      tree_key: 0,
      selectionData: [],
      treeData: {},
      first: true,
      notCompleted: false,
      showPreview: false,
      orignChildrenList: [], // 未修改的目录
      treeUtils: new TreeUtils({ idFieldName: "folderId", childrenFieldName: "childrenList", nameFieldName: "folderName", parentIdFieldName: "parentId" })
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      catalogInit: (state) => state.projectMg.catalogInit,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    showUserPlan() {
      const v = globalParams.get("prjPlan.disableUserPlan") ?? 0;
      return !v;
    },
    optColumnProps() {
      return this.showUserPlan
        ? {
          width: "100px",
          align: "center"
        }
        : {};
    },
    treeColumnProps() {
      return this.showUserPlan
        ? {
          minWidth: "200px"
        }
        : {
          width: "300px"
        };
    },
    folderTypeEnum() {
      const obj = {};
      const icons = {
        stage: stageIcon,
        child: childIcon,
        spec: specIcon
      };
      for (const { typeName, name, key } of this.orderAssistants) {
        obj[typeName] = { name, icon: icons[key] };
      }
      return obj;
    }
  },
  watch: {
    directoryStatus(newValue) {
      if (newValue === "0") {
        this.$refs.selectOrderRuleDlg.orderKey = this.orderKey;
        this.$refs.selectOrderRuleDlg.show();
      } else if (newValue === "2") {
        this.setCatalogToken("1");
      }
      this.csgetParams = this.getSaveParams();
    },

    prjInfo(newValue) {
      if (newValue.prjId) {
        this.fetchData();
      }
    },
    csgetParams: {
      deep: true,
      handler(value) {
        if (!this.checkSave()) {
          this.$store.dispatch("setCheckSave", "1");
          window.onbeforeunload = null;
          window.onbeforeunload = function () {
            return "";
          };
        } else {
          this.$store.dispatch("setCheckSave", "0");
          window.onbeforeunload = null;
        }
      }
    }
  },

  mounted() {
    this.fetchData();
  },
  beforeDestroy() {
    window.onbeforeunload = null;
  },
  methods: {
    ...mapActions(["setCatalogToken"]),
    async triggerAside() {
      this.showPreview = !this.showPreview;
      await this.$nextTick();
      if (this.showPreview) {
        this.$refs.previewTree.refresh();
      }
    },
    // 第一个参数是调用方法,后续参数作为入参输入
    handleCommand([fn, ...args]) {
      Reflect.apply(fn, this, args);
    },
    async addUser(row, { id, nameKey }) {
      const ids = row[id];
      const userIds = ids ? ids.join(",") : "";
      const list = await openMember({ userIds, codePri: ["User"] });
      row[id] = list.map(({ userId }) => userId);
      row[nameKey] = list.map(({ name }) => name).join(",");
    },
    // 项目初次初始化，选择了层级关系后触发
    onOrderKeyChanged(newOrderKey) {
      this.orderKey = newOrderKey;
      this.selectedOrderKey = newOrderKey;
      this.initCatalog();
    },

    initCatalog() {
      this.saveChange("init");
    },

    getAddTitle(name) {
      return name ? "添加" + name : "";
    },

    getCopyTitle(name) {
      return name ? "复用" + name : "";
    },

    // 页面上面的初始化选择器
    catalogChange(val) {
      this.orderKey = this.selectedOrderKey;
      if (this.catalogInit === "1") {
        this.$message.warning("目录已经发布，不能修改");
        this.orderKey = this.selectedOrderKey;
      } else {
        this.$confirm("切换层级目录将清空当前数据，是否继续", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false
        }).then(() => {
          this.orderKey = val;
          this.childrenList = [];
          this.initCatalog();
        });
      }
    },

    async saveChange(type) {
      this.saveChangeLoading = true;
      try {
        const params = this.getSaveParams();
        await folderService.dynamicSaveChange(params);
        this.csgetParams = params;
        if (!type) {
          this.$message.success("保存成功");
        }
        this.fetchData();
      } finally {
        this.saveChangeLoading = false;
      }
    },
    // 导出数据
    async exportList() {
      const res = await folderService.exportPrjPlan({ prjId: this.prjInfo.prjId });
      const fileName = "项目策划-" + this.prjInfo.prjId + "-" + this.prjInfo.prjName + ".xlsx";
      if (res instanceof Blob) {
        const url = URL.createObjectURL(res);
        const fakeLink = document.createElement("a");
        fakeLink.style.display = "none";
        fakeLink.href = url;
        fakeLink.setAttribute("download", fileName);
        fakeLink.click();
      } else {
        this.$message.warning("导出数据失败");
      }
    },
    async fetchData() {
      this.loading = true;
      try {
        const { data: resData } = await folderService.queryDynamicHomeList({ prjId: this.prjInfo.prjId });
        this.orderRuleList = resData.orderRuleList || [];
        this.orderKey = resData.orderKey || "";
        this.selectedOrderKey = resData.orderKey || "";
        this.directoryStatus = resData.directoryStatus;
        this.orderAssistants = resData.orderAssistants || [];
        this.butArr = [];
        for (var i = 0; i < this.orderAssistants.length; i++) {
          const orderItem = this.orderAssistants[i];
          if (i === 0) {
            const newBtn = {
              ...orderItem,
              subordinateKey: orderItem.key,
              action: "add",
              butName: "添加" + orderItem.name
            };
            this.butArr.push(newBtn);
          } else {
            const arr2 = {
              ...orderItem,
              subordinateKey: orderItem.key,
              action: "copyTo",
              butName: "复用" + orderItem.name
            };
            this.butArr.push(arr2);
          }
        }
        const childrenList = resData.childrenList || [];
        this.fillExtendedFields(childrenList);
        this.childrenList = childrenList;
        this.orignChildrenList = cloneDeep(childrenList);
        this.csgetParams = this.getSaveParams();
        this.showPreview = false;
      } finally {
        this.loading = false;
      }
    },

    fillExtendedFields(items, parent) {
      if (!items) return;
      const list = Array.isArray(items) ? items : [items];
      if (!list.length) return;
      const { orderAssistants } = this;
      const { ...p } = parent || { level: -1 };
      const level = ~~p.level + 1;
      const currentOrder = orderAssistants[level] || {};
      if (!currentOrder) return;
      const subOrder = level < orderAssistants.length - 1 ? orderAssistants[level + 1] : {};
      for (const item of list) {
        item.canEdit = !!item.canEdit;
        // 当前级的类型名称与类型
        item.currentRuleName = currentOrder.name;
        item.currentRuleKey = currentOrder.key;
        // 下一级的类型名称与类型
        item.subordinateName = subOrder.name;
        item.subordinateKey = subOrder.key;
        // 当前层级的编号。从 0 开始
        item.level = level;
        item.childrenList ??= [];
        for (const { key, typeName } of orderAssistants) {
          const fieldKey = `${key}Id`;
          const curOrder = typeName === item.typeName;
          item[fieldKey] = curOrder ? item.typeId : p[fieldKey];
        }
        // 初始化 各类角色人员
        for (const { id, nameKey } of this.roleList) {
          item[id] ??= [];
          item[nameKey] ??= "";
        }
        this.fillExtendedFields(item.childrenList, item);
      }
    },
    disabledFu(val, index) {
      if (index === 0) {
        return false;
      } else {
        if (this.treeData.folderId) {
          return val.name !== this.treeData.subordinateName;
        } else {
          return true;
        }
      }
    },
    handleNodeClick(data) {
      this.treeData = data;
      if (!data.childrenList) {
        this.$set(data, "childrenList", []);
      }
    },
    handleBtnClick(nodeData, index, action) {
      const subordinateKey = nodeData.subordinateKey;
      this.selectionData = [];
      this.first = index === 0;
      if (action === "add") {
        switch (subordinateKey) {
          case "spec":
            this.$refs.selectSpecDlg.show(nodeData);
            break;
          case "child":
            this.$refs.selectChildDlg.show(nodeData);
            break;
          case "stage":
            this.$refs.selectStageDlg.show();
            break;
          case "unit":
            this.$refs.selectUnitDlg.show();
            break;
          default:
            console.warn("不能处理节点类型：", subordinateKey);
            break;
        }
      } else if (action === "copyTo") {
        nodeData.currentRuleKey = this.treeData.currentRuleKey;
        nodeData.currentRuleName = this.treeData.currentRuleName;
        nodeData.folderId = this.treeData.folderId;
        nodeData.canEdit = this.treeData.canEdit;
        nodeData.childrenList = this.treeData.childrenList;
        nodeData.level = this.treeData.level;
        const index = this.treeData.parentId === "0" ? 2 : 4;
        this.$refs.copyToDlg.show(nodeData, index);
      }
    },
    disabledDn(data) {
      const parent = this.getParentRow(data);
      const list = parent.childrenList;
      return data.orderNum === list[list.length - 1].orderNum;
    },
    disabledUp(data) {
      const parent = this.getParentRow(data);
      const list = parent.childrenList;
      return data.orderNum === list[0].orderNum;
    },
    async nodeUp(data) {
      const children = this.getParentRow(data)?.childrenList;
      const cIndex = children.findIndex((d) => d.folderId === data.folderId);
      const tempChildrenNodex1 = children[cIndex - 1];
      const tempChildrenNodex2 = children[cIndex];
      const orderNum1 = tempChildrenNodex1.orderNum;
      tempChildrenNodex1.orderNum = tempChildrenNodex2.orderNum;
      tempChildrenNodex2.orderNum = orderNum1;
      this.$set(children, cIndex - 1, tempChildrenNodex2);
      this.$set(children, cIndex, tempChildrenNodex1);
      this.tree_key++;
      this.$parent.queryfabutips();
      // 点击上下移以后 查询一下当前数据 防止点击预览 数据不是最新的
      this.csgetParams = this.getSaveParams();
      await this.$nextTick();
      this.handleNodeClick(tempChildrenNodex1);
      this.$refs.tree.setCurrentRow(tempChildrenNodex1);
    },
    async nodeDown(data) {
      const children = this.getParentRow(data).childrenList;
      const cIndex = children.findIndex((d) => d.folderId === data.folderId);
      const tempChildrenNodex1 = children[cIndex + 1];
      const tempChildrenNodex2 = children[cIndex];
      const orderNum1 = tempChildrenNodex1.orderNum;
      tempChildrenNodex1.orderNum = tempChildrenNodex2.orderNum;
      tempChildrenNodex2.orderNum = orderNum1;
      this.$set(children, cIndex + 1, tempChildrenNodex2);
      this.$set(children, cIndex, tempChildrenNodex1);
      this.tree_key++;
      this.$parent.queryfabutips();
      // 点击上下移以后 查询一下当前数据 防止点击预览 数据不是最新的
      this.csgetParams = this.getSaveParams();
      await this.$nextTick();
      this.handleNodeClick(tempChildrenNodex1);
      this.$refs.tree.setCurrentRow(tempChildrenNodex1);
    },
    handleAddChildNode(nodeData) {
      this.treeData = nodeData;
      this.handleBtnClick(nodeData, -1, "add");
    },
    copyChildrenTo(data) {
      this.treeData = data;
      const index = this.treeData.parentId === "0" ? 2 : 4;
      this.handleBtnClick(data, index, "copyTo");
    },
    getParentRow({ parentId }) {
      const { childrenList } = this;
      const flatList = [{ folderId: "0", childrenList }];
      for (const item of flatList) {
        if (parentId === item.folderId) return item;
        const list = item.childrenList || [];
        if (list.length) {
          flatList.push(...item.childrenList);
        }
      }
    },
    async remove(data) {
      await this.$confirm("确认要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false
      });
      // 点击删除以后 查询一下当前数据 防止点击预览 数据不是最新的
      this.csgetParams = this.getSaveParams();
      const parent = this.getParentRow(data);
      const childrenList = parent.childrenList || this.childrenList;
      const index = childrenList.findIndex((d) => d.folderId === data.folderId);
      childrenList.splice(index, 1);
      this.treeData = {};
      this.$parent.queryfabutips();
      this.$message({
        type: "success",
        message: "删除成功!"
      });
    },

    getSaveParams() {
      const params = {
        enterpriseId: this.enterpriseId,
        orderKey: this.orderKey,
        prjId: this.prjInfo.prjId,
        prjCode: this.prjInfo.prjCode,
        childrenList: this.childrenList
      };
      return params;
    },
    checkPublishDataCompleted(data, typeName) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].typeName !== typeName) {
          if (data[i].childrenList?.length) {
            this.notCompleted = false;
            this.checkPublishDataCompleted(data[i].childrenList, typeName);
          } else {
            this.notCompleted = true;
          }
        }
      }
    },
    async publishChange() {
      if (this.directoryStatus === "0") {
        this.$message.warning("请先初始化目录");
        return;
      }
      this.publishChangeLoading = true;
      try {
        const params = this.getSaveParams();
        this.csgetParams = this.getSaveParams();
        if (this.childrenList.length === 0) {
          return;
        }
        const typeName = this.orderAssistants[this.orderAssistants.length - 1].typeName;
        this.checkPublishDataCompleted(this.childrenList, typeName);
        if (!this.notCompleted) {
          await this.$confirm("发布完成后，文档目录将同步修改，是否继续?", "提示", { type: "warning" });
        } else {
          let messageTitle = "";
          for (let e = 1; e < this.orderAssistants.length; e++) {
            messageTitle += " " + this.orderAssistants[e].name + " 和";
          }
          // 去掉最后一个符号
          messageTitle = messageTitle.substring(0, messageTitle.length - 1);
          await this.$confirm(this.orderAssistants[0].name + "下的" + messageTitle + "的策划未完整，确认提交吗？您可以在提交后，继续完善策划。");
        }
        // 策划不完整也可以发布
        await folderService.publishDynamic(params);
        this.$parent.fabutipsshowFu();
        this.publishChangeLoading = false;
        this.$store.dispatch("setCatalogToken", "1"); // 发布过
        this.$message.success("发布成功");
        this.csgetParams = this.getSaveParams();
        this.fetchData();
      } catch (e) {
        console.log("校验出错", e);
        this.publishChangeLoading = false;
      } finally {
        this.publishChangeLoading = false;
      }
    },

    async rollback() {
      if (this.directoryStatus !== "1") {
        this.$message.warning("暂无要恢复的数据");
        return;
      }
      this.rollbackLoading = true;
      try {
        await this.$confirm("恢复至上一次发布状态后，当前修改内容将丢失并且不可找回，是否继续", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false
        });
        await folderService.dynamicRollback({ prjId: this.prjInfo.prjId });
        this.rollbackLoading = false;
        this.$parent.fabutipsshowFu();
        this.$message.success("恢复成功");
        this.fetchData();
      } finally {
        this.rollbackLoading = false;
      }
    },

    async afterSpecSelected(data) {
      this.addNewNodesToTree(data, "specName", "specId", "templateSpecId");
    },

    async afterChildSelected(data) {
      this.addNewNodesToTree(data, "childName", "childId", "childNo");
    },

    async afterStageSelected(data) {
      this.addNewNodesToTree(data, "stageName", "stageId", "templateStageId");
    },

    async afterUnitSelected(data) {
      this.addNewNodesToTree(data, "stageName", "stageId", "templateStageId");
    },

    async addNewNodesToTree(data, folderNameFieldName, typeIdFieldName, folderNoFieldName) {
      this.$parent.queryfabutips();
      this.csgetParams = this.getSaveParams();
      if (!folderNameFieldName || !typeIdFieldName) {
        throw new Error("参数错误");
      }
      const selectionData = data.selectionData;
      const parentNodeData = data.parentNodeData;
      const typeName = data.val;
      if (!selectionData.length) {
        return;
      }
      const isParentNull = this.first || !parentNodeData || !parentNodeData.folderId;
      let num1 = isParentNull ? this.neworderNum(this.childrenList) : this.neworderNum(parentNodeData.childrenList);
      for (const item of selectionData) {
        const newNodeData = this.newNode(parentNodeData, num1++);
        newNodeData.folderName = item[folderNameFieldName];
        newNodeData.folderNo = item[folderNoFieldName];
        newNodeData.typeId = item[typeIdFieldName];
        newNodeData.typeName = typeName;
        newNodeData.canEdit = true;
        if (isParentNull) {
          // 一级节点
          this.fillExtendedFields(newNodeData);
          this.childrenList.push(newNodeData);
        } else {
          // 非一级节点
          this.fillExtendedFields(newNodeData, parentNodeData);
          parentNodeData.childrenList.push(newNodeData);
        }
      }
    },
    neworderNum(data) {
      return data.length ? data[data.length - 1].orderNum + 1 : 1;
    },

    newNode(parentNodeData, orderNum) {
      const isParentNull = this.first || !parentNodeData || !parentNodeData.folderId;
      return {
        folderId: uuidv4().replace(/-/g, ""),
        folderName: "",
        typeId: "",
        parentId: isParentNull ? "0" : parentNodeData.folderId,
        prjId: this.prjInfo.prjId,
        enterpriseId: this.enterpriseId,
        orderNum: orderNum,
        isDelete: 0,
        isActive: 1,
        typeName: null,
        canEdit: true,
        isPublish: 0,
        childrenList: []
      };
    },

    handleCopyTo(data) {
      this.$parent.queryfabutips();
      this.csgetParams = this.getSaveParams();
      const { itemsToCopy, targetParent } = data;
      this.selectionData = itemsToCopy;
      const folderIds = targetParent;
      const parentNodes = this.treeUtils.findTreeNodes(this.childrenList, folderIds);
      for (const childNode of itemsToCopy) {
        for (const parentNode of parentNodes) {
          this.treeUtils.addNodeTo(parentNode, childNode, (childNode) => {
            // 在这个回调里，刷新节点的 id, 并递归地更新子节点的 parentId
            const num = this.neworderNum(parentNode.childrenList);
            this.refreshFolderIdOfNodeRecursive(childNode, num);
            // 复制过来的数据需要重置发布状态
            childNode.isPublish = 0;
            // 复制重置权限
            childNode.canEdit = true;
          });
        }
      }
      for (const parentNode of parentNodes) {
        this.fillExtendedFields(parentNode.childrenList, parentNode);
      }
    },

    refreshFolderIdOfNodeRecursive(node, num) {
      this.treeUtils.wtravel(node, null, false, (node) => {
        if (!node.hasNewFolderId) {
          node.folderId = uuidv4().replace(/-/g, "");
          node.hasNewFolderId = true;
          node.orderNum = num++;
          // 改了节点的 id 后，要把它下面的子节点的 parentId 同样要改掉
          if (node.childrenList && node.childrenList.length) {
            node.childrenList.forEach((child) => (child.parentId = node.folderId));
          }
        }
      });
      this.treeUtils.wtravel(node, null, false, (node) => {
        node.hasNewFolderId = false;
      });
    },

    toggleDisabled(data) {
      this.$parent.queryfabutips();
      // 点击禁用 启用以后 查询一下当前数据 防止点击预览 数据不是最新的
      this.csgetParams = this.getSaveParams();
      data.isActive = 1 - (data.isActive || 0);
    },
    isObject(obj) {
      return Object.prototype.toString.call(obj) === "[object Object]";
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    // 检查保存
    checkSave() {
      const childrenList = this.childrenList || [];
      return isEqual(this.orignChildrenList, childrenList);
    },
    editFolderNo(row) {
      this.$refs.editFolderNoDlg.show(row);
    }
  }
};
</script>

<style lang="scss" scoped>
$color: #4777e7;

.f-icon {
  vertical-align: middle;
}

.el-container.outer {
  height: calc(100% + 20px);
  margin: -10px -32px -10px -20px;

  .el-container {
    height: 100%;

    .el-container {
      height: calc(100% - 60px);

      .el-main {
        height: 100%;
        width: 100%;
        display: flex;
        padding: 10px;

        /deep/ .custom-tree-node {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          padding-right: 8px;
          width: 95%;

          .folderNameStyle {
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }

      .el-footer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
  }

  .el-aside {
    border-left: 1px solid rgb(235, 239, 255);

    .el-card {
      border: none;
      height: calc(100% - 5px);
      border-radius: 0;

      &__header {
        .clearfix {
          text-align: center;

          & > span {
            position: relative;
            top: 5px;
            left: -18px;
          }

          .el-button {
            float: left;
          }
        }
      }

      &__body {
        height: calc(100% - 100px);
        overflow: auto;
      }
    }
  }

  /deep/ .profession-dialog {
    border-radius: 5px;

    .el-dialog__body {
      padding: 20px;
      border-top: 1px solid #2e5bff1a;
      border-bottom: 1px solid #2e5bff1a;
    }
  }

  .buttons .el-button {
    padding-left: 2px;
  }
}

.tree-name {
  color: #f56c6c;

  &.isActive {
    color: #606266;
  }
}

.relative {
  position: relative;
}

.level-stage {
  position: absolute;
  inset: 0;
  margin: 5px 0;
}

.preview-tips {
  $lh: 42px;
  $aw: 14px;
  $radio: 6px;
  position: absolute;
  top: 18px;
  right: $aw;
  width: $aw;
  height: $lh;
  line-height: $lh * 1.2;
  border-radius: $radio 0 0 $radio;
  background-color: $color;
  cursor: pointer;
  overflow: hidden;
  z-index: 1;

  &:hover {
    background-color: lighten($color, 6%);
  }

  &.open {
    border-radius: 0 $radio $radio 0;
    right: $aw * -1;
  }

  > i {
    font-size: $lh * 0.5;
    margin-left: 4px;
    color: #fff;
  }
}

.ml-0 {
  margin-left: 0;
}
</style>

